
































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MonitoringKritisIgdKpiHeader extends Vue {
  @Prop() monitoring!: any;

  elapsedTimer: any = null;
  elapsedTime = "-";

  mounted() {
    this.startElapsedTimer();
  }

  beforeDestroy() {
    if (this.elapsedTimer) clearInterval(this.elapsedTimer);
  }

  startElapsedTimer() {
    if (this.monitoring?.arrival_at && !this.monitoring?.disposisi_at) {
      this.elapsedTimer = setInterval(() => {
        const arrival = new Date(this.monitoring.arrival_at).getTime();
        const now = Date.now();
        const diffMin = Math.floor((now - arrival) / 60000);
        const jam = Math.floor(diffMin / 60);
        const menit = diffMin % 60;
        this.elapsedTime = jam > 0 ? `${jam}j ${menit}m` : `${menit}m`;
      }, 60000);
      // immediate first call
      const arrival = new Date(this.monitoring.arrival_at).getTime();
      const now = Date.now();
      const diffMin = Math.floor((now - arrival) / 60000);
      const jam = Math.floor(diffMin / 60);
      const menit = diffMin % 60;
      this.elapsedTime = jam > 0 ? `${jam}j ${menit}m` : `${menit}m`;
    }
  }

  get ewssTrend(): number[] {
    const ttvs = this.monitoring?.ttvs || [];
    return ttvs
      .filter((t: any) => t.ewss_total !== null)
      .slice(-6)
      .map((t: any) => t.ewss_total);
  }

  get gcsTrend(): number[] {
    const ttvs = this.monitoring?.ttvs || [];
    return ttvs
      .filter((t: any) => t.gcs_total !== null)
      .slice(-6)
      .map((t: any) => t.gcs_total);
  }

  ewssColor(kategori: string) {
    const colors: Record<string, string> = {
      normal: "green", ringan: "green", sedang: "amber darken-2", tinggi: "red", blue: "blue",
    };
    return colors[kategori] || "grey";
  }
}
